import { EventSlot } from "../../../library-js/events/EventSlot";
import { Arrays } from "../../../library-js/tools/Arrays";
import { Request } from "../../../library/ts/html/server/Request";
import { Rokojori } from "../Rokojori";
import { AssetInfo } from "./AssetInfo";
import { AssetManagerServer } from "./AssetManagerServer";
import { PersonalData } from "../../../library/ts/vanilla/ecommerce/PersonalData";
import { SetCartItems } from "../cart/SetCartItems";
import { block } from "../../../library-js/css/CSSDisplay";

export class CartData
{
  token:string;
  update:boolean = false;
  wishlist:string[];
  cart:string[];
  personalData:PersonalData;
  updatePersonalData:boolean;
  hideQuestion:boolean;
}

export class SessionID
{
  id:string;
}

export class AssetsCart
{
  enabled:boolean = false;
  wishlist:string[] = [];
  cart:string[] = [];
  personalData:PersonalData;
  hideQuestion:boolean = false;

  onChanged = new EventSlot();

  async getSessionID():Promise<SessionID>
  {    
    return Request.get( "/_php/session-id.php" );
  }



  async sync():Promise<void>
  {    
    if ( ! this.enabled )
    {
      return Promise.resolve();
    }

    let rk = Rokojori.$;
    let url = AssetManagerServer.serverURL + "/cart";
    let token = await this.getSessionID();

    let cartData = new CartData();
    cartData.token = token.id;

    let serverCartData =  null;

    try
    {
      serverCartData = await Request.post<CartData,CartData>( url, cartData );
    }
    catch ( e )
    {
      console.log( e );
      return;
    }


    if ( serverCartData != null )
    {
      this.cart = serverCartData.cart;
      this.wishlist = serverCartData.wishlist;

      if ( serverCartData.personalData )
      {
        this.personalData = serverCartData.personalData;
      }
      

      console.log("SYNC", serverCartData );
    }

    return Promise.resolve();
  }

  


  async update():Promise<void>
  {
    let rk = Rokojori.$;
    let url = AssetManagerServer.serverURL + "/cart";
    let token = await this.getSessionID();

    let cartData = new CartData();
    cartData.token = token.id;
    cartData.wishlist = this.wishlist;
    cartData.cart = this.cart;
    cartData.update = true;
    cartData.hideQuestion = this.hideQuestion;

    let serverCartData = await Request.post<CartData,CartData>( url, cartData );

    if ( serverCartData )
    {
      this.cart = serverCartData.cart;
      this.wishlist = serverCartData.wishlist;

      console.log( "update", this );
    }

    this.onChanged.dispatch( null );

    return Promise.resolve();
  }

  async savePersonalData():Promise<void>
  {
    let rk = Rokojori.$;
    let url = AssetManagerServer.serverURL + "/cart";
    let token = await this.getSessionID();

    let cartData = new CartData();
    cartData.token = token.id;
    cartData.wishlist = this.wishlist;
    cartData.cart = this.cart;
    cartData.update = true;
    cartData.personalData = this.personalData;
    cartData.updatePersonalData = true;

    let serverCartData = await Request.post<CartData,CartData>( url, cartData );

    if ( serverCartData )
    {
      this.cart = serverCartData.cart;
      this.wishlist = serverCartData.wishlist;
      this.personalData = serverCartData.personalData;

      console.log( "savePersonalData", this );
    }

    this.onChanged.dispatch( null );

    return Promise.resolve();
  }

  async add( id:string, wishlist:boolean )
  {
    if ( wishlist )
    {
      this.wishlist.push( id )
    } 
    else
    {
      this.cart.push( id )
    }       

    return this.update();
  }

  async remove( id:string, wishlist:boolean )
  {
    if ( wishlist )
    { 
      Arrays.remove( this.wishlist, id );
    } 
    else
    {
      Arrays.remove( this.cart, id );
    }    

    return this.update();
  }

  async clearWishlist():Promise<void>
  {
    this.wishlist = [];

    return this.update();
  }

  async clearCart():Promise<void>
  {
    this.cart = [];

    return this.update();
  }
}